// extracted by mini-css-extract-plugin
module.exports = {"aboveTheFoldEventsTable":"DesktopProfileActivityFeed_aboveTheFoldEventsTable__2UIky","nounInfoPadding":"DesktopProfileActivityFeed_nounInfoPadding__2Bhvn"};